let baseUrl = "";

switch (process.env.NODE_ENV) {
  case "development":
    baseUrl = "/api"; // 开发环境使用代理
    // baseUrl = "https://api-test.tuxymat.ch"; //测试环境
    // baseUrl = "http://192.168.110.209:8089"; //测试环境
    break;
  case "cloud":
    baseUrl = "https://api-test.tuxymat.ch"; //测试环境
    break;
  case "production":
    baseUrl = "https://api-test.tuxymat.ch"; //测试环境
    // baseUrl = "https://api.tuxymat.ch"; //生产环境
    break;
}
let config = {
  method: "get",
  // 基础url前缀
  baseUrl: baseUrl,
  // 请求头信息
  header: {
    "Content-Type": "application/json;charset=UTF-8"
  },
  // 参数
  data: {},
  // 设置超时时间
  timeout: 60000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: "json",
  // 系统版本 2.0=>2 3.0=>3
  sysversion: "3.0"
};

export default config;
